import React from 'react';
import { Outlet, useLocation } from 'react-router';

// This component will enhance all the routes rendered with scroll to top behavior on landing. It is
// simply a hook that will scroll to the top of the page if the pathname changes, and lets the browser
// preserve page location if the user uses the back or forward button to navigate.
export function ScrollToTop() {
  const location = useLocation();

  React.useEffect(() => {
    // If an anchor tag is present, do not scroll to the top
    if (!location.hash) {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return null;
}

// Layout route wrapping every top-level route (see build_root_routes).
export default function RootRoute() {
  return (
    <div>
      <ScrollToTop />
      <Outlet />
    </div>
  );
}
